import { useRouter } from '@abyss/web/hooks/useRouter';
import { Flex } from '@abyss/web/ui/Flex';
import { LoadingSpinner } from '@abyss/web/ui/LoadingSpinner';
import React, { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useMaestroStore } from '../../store/useMaestroStore';
import { MaestroState } from '../../store/useMaestroStore/maestroStore';

const requestBody = {
  zip: '76119',
  fipsCode: '48439',
  year: '2026',
  clientProdCode: '/',
  client: 'MIIM',
  targetUrl:
    'https://maestrostg.uhc.com/prweb/PRHTTPService/RALLY/ProviderServices/PostProviderInfo',
  planTypes: ['M'],
  enforceDistinctPCP: 'true',
  MBI: '5FG6WG0RN83',
};

const navigateUrl =
  '/plan-selection?planSelectionLob=MR&coverageType=M&chipValue=All';

const postMaestroData = (): Promise<typeof requestBody> =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(requestBody);
      } catch (err) {
        reject(
          new Error(`Failed to process request: ${(err as Error).message}`)
        );
      }
    }, 1500);
  });

export const Acquisition = () => {
  const { navigate } = useRouter();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const { setIsNavigatingMaestro, setMaestroRequestData } = useMaestroStore(
    useShallow((state: MaestroState) => ({
      setIsNavigatingMaestro: state.setIsNavigatingMaestro,
      setMaestroRequestData: state.setMaestroRequestData,
    }))
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestBody = await postMaestroData();
        const isNavigatingToMaestro = requestBody.client === 'MIIM';
        setMaestroRequestData(requestBody);
        setIsNavigatingMaestro(isNavigatingToMaestro);
        navigate(navigateUrl);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading)
    return (
      <Flex
        alignItems="center"
        css={{
          height: '100%',
        }}
        id="acquisition-loading"
        justify="center"
      >
        <LoadingSpinner
          ariaLoadingLabel="loading results"
          data-testid="loading-spinner"
          isLoading
          size="$lg"
        />
      </Flex>
    );
  if (error) return <p>Error: {error}</p>;
  return null;
};
